<span class="state {{getStatusPrice(price)}} {{getStatusOfPrice(price)}} gap-4px"> 
    <div class="circle"></div> {{getStatusPrice(price)}}
</span>